module.exports = __webpack_public_path__ + "img/dlrb.6944ba37.jpg";